
import Vue from 'vue';

export default Vue.extend<any, any, any, any>({
  name: 'DatePicker',
  props: {
    defaultDate: {
      type: String
    },
    updateDate: {
      type: Function
    },
    rangeYear: {
      type: Number
    },
    isDob: {
      type: Boolean,
      default: false
    },
    minYear: {
      type: Number
    },
    maxYear: {
      type: Number,
      default: () => new Date().getFullYear()
    },
    hideDate: {
      type: Boolean,
      default: false
    },
    hideMonth: {
      type: Boolean,
      default: false
    },
    hideYear: {
      type: Boolean,
      default: false
    },
    monthList: {
      type: Array,
      default: () => [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ]
    }
  },
  data() {
    return {
      selDate: {
        date: '',
        month: '',
        year: ''
      },
      handlers: {
        scroll: this.handleScroll,
        mousedown: this.handleMouseDown,
        mousemove: this.handleMouseMove,
        mouseleave: this.handleMouseLeave,
        mouseup: this.handleMouseUp,
        touchmove: this.handleMouseMove,
        touchend: this.handleMouseLeave,
        click: this.handleClick
      },
      isDown: false,
      startY: 0,
      ready: false
    };
  },
  watch: {
    defaultDate(val) {
      if (val !== null) {
        this.ready = false;
        this.removeScrollerClass(this.$refs.yearContainer);
        this.removeScrollerClass(this.$refs.monthContainer);
        this.removeScrollerClass(this.$refs.dateContainer);

        const currDate = new Date(val);
        this.selDate.date = currDate.getDate();
        this.selDate.month = currDate.getMonth() + 1;
        this.selDate.year = currDate.getFullYear();
        this.initDate();
      }
    }
  },
  mounted() {
    const currDate = new Date(this.defaultDate);
    if (!isNaN(currDate.getTime())) {
      this.selDate.date = currDate.getDate();
      this.selDate.month = currDate.getMonth() + 1;
      this.selDate.year = currDate.getFullYear();
    }
    this.initDate();
  },
  methods: {
    handleMouseDown(e: any) {
      this.isDown = true;
      this.startY = e.pageY - e.target.offsetTop;
      this.scrollTop = e.target.scrollTop;
    },
    handleClick(e: any) {
      e.srcElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    },
    handleMouseMove(e: any) {
      if (!this.isDown) return;
      e.preventDefault();
      const Y = e.pageY - e.target.offsetParent.offsetTop;
      const walk = Y - this.startY;
      e.target.offsetParent.scrollTop = this.scrollTop - walk;
    },
    handleMouseLeave() {
      this.isDown = false;
    },
    handleMouseUp() {
      this.isDown = false;
    },
    generateMonth() {
      return this.monthList;
    },
    generateDate() {
      const endDate = new Date(this.selDate.year, this.selDate.month, 0);
      const lastDay = endDate.getDate();
      const days = [];
      for (let date = 1; date <= lastDay; date++) {
        days.push(date);
      }
      return days;
    },
    setRef(ref: any) {
      const elOffset = ref[0].offsetTop;
      ref[0].offsetParent.scrollTop = elOffset - 30;
    },
    addScrollerClass(containerRef: any) {
      if (containerRef) {
        containerRef.classList.add('scroller');
      }
    },
    removeScrollerClass(containerRef: any) {
      if (containerRef) {
        containerRef.classList.remove('scroller');
      }
    },
    initDate() {
      let containers: HTMLCollectionOf<Element> = ([] as never) as HTMLCollectionOf<Element>;
      if (this.$attrs.id) {
        containers =
          ((document.querySelectorAll(`#${this.$attrs.id} .datePicker__itemContainer`) as never) as HTMLCollectionOf<
            Element
          >) || [];
      } else {
        containers = document.getElementsByClassName('datePicker__itemContainer') || [];
      }

      this.$nextTick(() => {
        const yearRef = this.$refs[`year_${parseInt(this.selDate.year)}`];
        const monthRef = this.$refs[`month_${parseInt(this.selDate.month)}`];
        const dateRef = this.$refs[`date_${parseInt(this.selDate.date)}`];

        if (containers.length > 0) {
          if (yearRef && yearRef.length !== 0) this.setRef(yearRef);
          if (monthRef && monthRef.length !== 0) this.setRef(monthRef);
          if (dateRef && dateRef.length !== 0) this.setRef(dateRef);

          this.addScrollerClass(this.$refs.yearContainer);
          this.addScrollerClass(this.$refs.monthContainer);
          this.addScrollerClass(this.$refs.dateContainer);
          this.ready = true;
        }
      });
    },
    generateYearList() {
      const startYear = this.minYear ? this.minYear : this.maxYear - this.rangeYear;
      const rangeYear = this.minYear ? this.maxYear - this.minYear : this.rangeYear;
      const rangeYearArr = [startYear];
      Array.from(Array(rangeYear).keys()).map(item => {
        rangeYearArr.push(startYear + item + 1);
      });
      return rangeYearArr;
    },
    updateParentDate() {
      const { date, month, year } = this.selDate;
      const formatSelDate = `${year}-${`0${month}`.slice(-2)}-${`0${date}`.slice(-2)}`;
      // const selDate = new Date(year, month - 1, date);

      // const ageDate = new Date(Date.now() - selDate.getTime());

      // if (this.isDob) {
      //   const result = {
      //     date: formatSelDate,
      //     age: Math.abs(ageDate.getUTCFullYear() - 1970)
      //   };
      //   return this.$emit('updateDate', result);
      // } else {
      return this.$emit('updateDate', formatSelDate);
      // }
    },
    setCurrenteDate(item: any) {
      if (item.id) {
        item.classList.add('active');
        if (item.id.includes('date')) {
          this.selDate.date = item.id.split('_')[2];
        } else if (item.id.includes('month')) {
          this.selDate.month = item.id.split('_')[2];
        } else if (item.id.includes('year')) {
          this.selDate.year = item.id.split('_')[2];
        }
        this.updateParentDate();
        this.$forceUpdate();
      }
    },
    unsetDate(item: any) {
      if (item.id) {
        item.classList.remove('active');
      }
    },
    checkInView(elem: any, container: any) {
      if (elem.id) {
        let contHeight = container.offsetHeight;
        let elemTop = elem.getBoundingClientRect().top - container.getBoundingClientRect().top;
        let elemBottom = elemTop + elem.offsetHeight;
        let isViewed = elemTop >= 0 && elemBottom <= contHeight && elemBottom > 60;
        return isViewed;
      }
      return false;
    },
    handleScroll(event: any) {
      if (this.ready) {
        const children = event.target.childNodes;
        for (let i = 0; i < children.length; i++) {
          if (this.checkInView(children[i], event.target)) {
            this.setCurrenteDate(children[i]);
          } else {
            this.unsetDate(children[i]);
          }
        }
      }
    }
  }
});
